import gql from "graphql-tag";

export default gql`
  fragment FinancialSegmentsFields on FinancialSegments {
    periodEndingDate
    currency
    revenueModelSummary
    segments {
      name
      isPrimary
      ... on FinancialBusinessSegment {
        description
      }
      ... on FinancialGeographicSegment {
        isoCountryCode
        description
      }
      ratioAdjustedIndicators {
        name
        value
        history {
          periodEndingDate
          value
        }
      }
      financialIndicators {
        name
        value
        history {
          periodEndingDate
          value
        }
      }
    }
  }
`;
